module.exports = __webpack_public_path__ + "media/packs/images/sample-coverage-e187fc831d1aea13add0df4f2c7b210f.png";